<template>
<div class="editMode" @keyup="enter">
    <otif-textInput
        :name="field.name"
        :label="field.label"
        :description="field.description"
        :value="value"
        @input="input"
        :validation="validation"
        :invalidMessage="column.invalidMessage">
    </otif-textInput>
</div>
</template>

<script>

// import TextInput from '@mtm-studio-components/src/components/forms/TextInput.vue';

export default {

    computed: {
        field() {
            return {
                'label': this.column.label,
                'name': this.column.name
            }
        },

        validation() {
            if (this.$v && this.$v['editedRowKeyedData']) {
                return this.$v['editedRowKeyedData'][this.column.name];
            }
        }
    },

    watch: {
        value(newVal) {
            if (this.$v && this.$v['editedRowKeyedData']) {
                this.$v['editedRowKeyedData'][this.column.name].$touch();
            }
        }
    },

    methods: {
        input(changedValue) {

            this.$emit('input', changedValue);
        },

        enter($e) {
            if ($e.keyCode === 13) {
                $e.stopPropagation();
                $e.preventDefault();
                this.$emit('save', this.rowNumber);
            }
        }
    },
    props: ['value', 'columns', 'colNumber', 'rowNumber', 'column', '$v']
}
</script>

